import { courseGroupByProgram } from '~/data/courseGroups'
import type { CourseId } from '~/data/courses'
import { enrolmentComparisons, type EnrolmentComparisonsTable } from '~/data/enrolmentComparisons'
import { type ProgramId, programs } from '~/data/programs'
import type { CourseFeeId } from '~/data/courseFees'

export type EnrolmentId =
  | 'enrol-m1-self'
  | 'enrol-m1-blockchain-self'
  | 'enrol-ca-self'
  | 'enrol-capt-self'
  | 'enrol-kydp-2024'
  | 'enrol-kydp-2024-b'

export type Enrolment = {
  id: EnrolmentId
  courses: CourseId[]
  programId?: ProgramId
  direct: boolean
  open: boolean
  fees?: CourseFeeId[]
  limitedRegions: boolean
  description?: {
    title: string
    points: string[]
  }
  comparisons?: EnrolmentComparisonsTable
}

const getCoursesByProgram = (programId: ProgramId) => {
  return courseGroupByProgram[programId]
}

export const enrolments: Enrolment[] = [
  {
    // direct enrolment will send users to a payment gateway
    id: 'enrol-m1-self',
    courses: ['m1py', 'm1sql', 'm1js'],
    direct: true,
    open: true,
    limitedRegions: false,
    fees: ['fee-m1'],
    description: {
      title: 'Purchase this course now and get instant access to:',
      points: [
        '90-days access to all online learning materials',
        'Instructor-led live tutorial sessions',
        'Marked project assignments',
        'Received industry-recognized certification upon completion'
      ]
    }
  },
  {
    // direct enrolment will send users to a payment gateway
    id: 'enrol-m1-blockchain-self',
    courses: ['m1blockchain'],
    direct: true,
    open: true,
    limitedRegions: false,
    fees: ['fee-m1-blockchain'],
    description: {
      title: 'Purchase this course now and get instant access to:',
      points: [
        '90-days access to all online learning materials',
        'Instructor-led live tutorial sessions',
        'Marked project assignments',
        'Received industry-recognized certification upon completion'
      ]
    }
  },
  {
    // non direct enrolment will send users to a generic enrolment form
    id: 'enrol-ca-self',
    courses: ['cada', 'caba', 'cafed', 'cabed'],
    direct: false,
    open: true,
    limitedRegions: true,
    fees: ['fee-ca-upfront', 'fee-ca-monthly'],
    description: {
      title: 'Start your application now and get access to:',
      points: [
        'Access to all online learning materials',
        'Instructor-led live tutorial sessions',
        'Marked project assignments',
        'Received industry-recognized certification upon completion'
      ]
    },
    comparisons: enrolmentComparisons
  },
  {
    // non direct enrolment will send users to a generic enrolment form
    id: 'enrol-capt-self',
    courses: ['capt'],
    direct: false,
    open: true,
    limitedRegions: true,
    fees: ['fee-capt-self', 'fee-capt-placement'],
    description: {
      title: 'Start your application now and get access to:',
      points: [
        'Access to all online learning materials',
        'Instructor-led live tutorial sessions',
        'Marked project assignments',
        'Received industry-recognized certification upon completion'
      ]
    }
  },
  {
    // Program enrolment will send users to didicateed program enrolment form
    id: 'enrol-kydp-2024',
    programId: 'kydp-2024',
    courses: getCoursesByProgram('kydp-2024'),
    direct: false,
    open: programs.find((program) => program.id === 'kydp-2024')?.applicationOpen ?? false,
    limitedRegions: true
  },
  {
    // Program enrolment will send users to didicateed program enrolment form
    id: 'enrol-kydp-2024-b',
    programId: 'kydp-2024-b',
    courses: getCoursesByProgram('kydp-2024-b'),
    direct: false,
    open: programs.find((program) => program.id === 'kydp-2024-b')?.applicationOpen ?? false,
    limitedRegions: true
  }
]
